<template>
  <v-app>
    <sheader></sheader>
    <v-main>
      <!-- <v-container class="pm-frame   mb-5"> -->
        <v-row style="height:100vh">
          <v-col  :xl="!sellerMenuMini ? '2' : '1'" :lg="!sellerMenuMini ? '3' : '1'"  :md="!sellerMenuMini ? '3' : '1'" class="py-0" v-if="!isMobile">
            <smenubar></smenubar>
          </v-col>
          <v-col  :xl="!sellerMenuMini ? '10' : '11'" :lg="!sellerMenuMini ? '9' : '11'"  :md="!sellerMenuMini ? '9' : '11'" class="py-5 my-3 ">
            <router-view></router-view>
          </v-col>
        </v-row>
      <!-- </v-container> -->
    </v-main>
    <sfooter></sfooter>
  </v-app>
</template>

<script>
import { mapActions, mapState } from "vuex";
import sheader from "@/components/layout/store/seller/Header";
import sfooter from "@/components/layout/store/seller/Footer";
import smenubar from "@/components/layout/store/seller/Sidebar";

export default {
  components: {
    sheader,
    smenubar,
    sfooter
  },

  data() {
    return {
      isMobile: false
    };
  },

  computed: {
    windowWidth() {
      return this.getWindowWidth();
    },
    ...mapState("storeSeller", ['sellerMenuMini']), 
  },

  methods: {
    ...mapActions("storeSeller", ["getStoreDetail"]), 
    getWindowWidth() {
      let screen = document.documentElement.clientWidth;
      if (screen <= 960) this.isMobile = true;
      else this.isMobile = false;
    }
  },

  created() {
    this.getStoreDetail();
    this.getWindowWidth();
    window.addEventListener("resize", this.getWindowWidth);
  },
  destroyed() {
    window.addEventListener("resize", this.getWindowWidth);
  }
};
</script>
